import { FC } from 'react';

import { PercentageBar } from '@builder';
import { SamplePercentageBarProps } from './SamplePercentageBar.types';
import {
  StyledPercentageBarByCollectionLocation,
  StyledPercentageBarByCollectionLocationTitle,
  StyledPercentageBarChart,
} from './SamplePercentageBar.styles';

const SamplePercentageBar: FC<SamplePercentageBarProps> = ({ percentageItems, isSeriesEmpty, label }) => {
  return (
    <StyledPercentageBarByCollectionLocation>
      <StyledPercentageBarByCollectionLocationTitle data-testid="percentage-bar-title">
        {label}
      </StyledPercentageBarByCollectionLocationTitle>
      <StyledPercentageBarChart>
        <PercentageBar isDataAvailable={!isSeriesEmpty} items={percentageItems} />
      </StyledPercentageBarChart>
    </StyledPercentageBarByCollectionLocation>
  );
};

export default SamplePercentageBar;
